// builder-components.ts
import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';

const HeaderCallComponent = dynamic(() => import('./header-call-component'));

Builder.registerComponent(HeaderCallComponent, {
  name: 'HeaderCallComponent',
  noWrap: true,
});
